<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Shipping Mark
          <v-spacer></v-spacer>
          <v-btn
            v-if="canCancel"
            color="red mr-6"
            depressed
            rounded
            dark
            @click="cancelBooking()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Cancel Booking</span>
          </v-btn>

          <BookingStatusSelect
           v-if="!loading"
           :status="booking.status" :small="false"
           @statusChange="statusChange"
           :bookingType="'main'"
           :itemId="id"
           :statuses="statuses"
           :mnus="mnus"
           >
          </BookingStatusSelect>
        </v-card-title>
        <v-card-subtitle>
          <v-text-field
            style="max-width:350px"
            :loading="savingShippingMark"
            v-model="booking.shipping_mark"
            outlined
            dense
            ref="shippingMark"
            hide-details
            class="mt-6"
            :readonly="isEditShippingMark ? false : true"
          >
            <template v-slot:append-outer v-if="forUpdate">
              <v-btn
                v-if="!isEditShippingMark"
                icon
                class="mt-n1"
                color="primary"
                @click="editShippingMark()"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="isEditShippingMark"
                icon
                class="mt-n1"
                color="red"
                @click="cancelUpdateShippingMark()"
              >
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
              <v-btn
                v-if="isEditShippingMark"
                icon
                class="mt-n1"
                color="primary"
                @click="updateShippingMark()"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-spacer></v-spacer>
        </v-card-subtitle>

        <v-card-text class="text--primary">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-account-outline
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{booking.client_name}}</v-list-item-title>
                    <v-list-item-subtitle>Bill To</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar-clock
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ booking.created_at | moment("MMM D, YYYY h:mm A") }}</v-list-item-title>
                    <v-list-item-subtitle>Created Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-face-agent
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{booking.sales_agent_name}}</v-list-item-title>
                    <v-list-item-subtitle>Sales Agent</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-if="booking.target_delivery_date">{{booking.target_delivery_date | moment("MMM D, YYYY")}}</v-list-item-title>
                    <v-list-item-title v-if="!booking.target_delivery_date">-</v-list-item-title>
                    <v-list-item-subtitle>Estimated Delivery Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
          </v-row>

          <!-- <div class="text-h6 mt-6 mb-2">
            Items
          </div> -->
          <AlertMessage :alerMessage="alerMessageUpdate"></AlertMessage>
          <v-sheet
            rounded
            class="pa-5 px-6 pb-7 mt-12 mb-4"
            color="#f3f3f3">

            <v-data-table
              :headers="headers"
              :items="booking.items"
              class="item-data-input item-data-input-edit"
              :loading="loading"
              :items-per-page="1000"
              hide-default-footer
              loading-text="Loading Items..."
              no-data-text="No Items"
              ref="table">

              <template v-slot:item.container_id="props">
                <v-select
                  v-model="props.item.container_id"
                  :items="containers"
                  class="bg-white"
                  menu-props="auto"
                  placeholder="Container"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  hide-details
                ></v-select>
              </template>

              <template v-slot:item.description="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.description"
                  placeholder="Description"
                  :disabled="!forEdit(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.qty="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.qty"
                  @focus="$event.target.select()"
                  placeholder="Qty"
                  dense
                  outlined
                  @keypress="filter($event)"
                  :disabled="!forEdit(props.item)"
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.item_length="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_length"
                  @focus="$event.target.select()"
                  placeholder="Length"
                  @keypress="filter($event)"
                  :disabled="!forEdit(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.item_width="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_width"
                  @focus="$event.target.select()"
                  placeholder="Width"
                  @keypress="filter($event)"
                  :disabled="!forEdit(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.item_height="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_height"
                  @focus="$event.target.select()"
                  placeholder="Height"
                  @keypress="filter($event)"
                  :disabled="!forEdit(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.cbm="props">
                <v-text-field
                  class="centered-input bg-white"
                  placeholder="CBM"
                  dense
                  :value="formatNumber(computeCBM(props.item))"
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.kg="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.kg"
                  @focus="$event.target.select()"
                  placeholder="KG"
                  @keypress="filter($event)"
                  :disabled="!forEdit(props.item)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <BookingStatusSelect
                  v-if="!loading && item.id != 0"
                  :status="item.status"
                  :small="true"
                  @statusChange="statusChange"
                  :bookingType="'item'"
                  :itemId="item.id"
                  :statuses="statuses"
                  :mnus="mnusItem"
                >
                </BookingStatusSelect>
                <v-icon
                  v-if="item.id == 0"
                  color=" darken-2"
                  style="float:left"
                  @click="deleteItem(item)">
                  mdi-close
                </v-icon>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  v-if="item.id != 0 && canDelete(item)"
                  color=" darken-2"
                  @click="confirmDelete(item)">
                  mdi-close
                </v-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="!isReadyForPickup(item)"
                      v-on="on"
                      icon
                      color="primary"
                      @click="readyForPickup(item)"
                    >
                      <v-icon>mdi-truck-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Arrived in Warehouse</span>
                </v-tooltip>
              </template>

              <template v-slot:body.append>
                <tr class="sm-hidden">
                  <td class="text-right" colspan="2"><strong>TOTAL</strong></td>
                  <td class="text-center">
                    <strong>{{ formatNumber(totalQty) }}</strong>
                  </td>
                  <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                    <strong>{{ formatNumber(totalKg) }}</strong>
                  </td>
                  <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                    <!-- <strong>{{ formatNumber(totalLength) }}</strong> -->
                  </td>
                  <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                    <!-- <strong>{{ formatNumber(totalWidth) }}</strong> -->
                  </td>
                  <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                    <!-- <strong>{{ formatNumber(totalHeight) }}</strong> -->
                  </td>
                  <td class="text-center">
                    <strong v-if="isShipmentForSea(booking.shipment_type)">{{ formatNumber(totalCbm) }}</strong>
                    <strong v-if="!isShipmentForSea(booking.shipment_type)">{{ formatNumber(totalKg) }}</strong>
                  </td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td class="text-center" :colspan="isShipmentForSea(booking.shipment_type) ? 10 : 7">
                    <div class="mt-4 mb-6">
                          <v-btn
                            fab
                            dark
                            small
                            depressed
                            color="primary"
                            class="mb-1"
                            @click="addMoreItems()"
                          >
                            <v-icon dark>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <br>
                          <span class="primary-color font-weight-medium">Add Item</span>
                    </div>
                  </td>
                </tr>
                <tr v-if="forUpdate">
                  <td class="text-center" :colspan="isShipmentForSea(booking.shipment_type) ? 10 : 7">
                    <!-- <v-divider class="mt-5 mb-5"></v-divider> -->
                    <div class="mt-5 mb-2">
                      <v-btn
                        v-if="!isEditShippingMark"
                        large
                        depressed
                        color="primary"
                        :disabled="!saveChangesEnable"
                        @click="update()"
                      >
                        Save Changes
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-sheet>

        </v-card-text>
        <v-card-title class="mb-4 mt-5">
          History
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-timeline
            dense
            align-top
          >
            <v-timeline-item
              :color="statusColor(0)"
              small
              large
              class="mt-n6"
            >
            <template v-slot:icon>
              <span class="white--text"><strong>{{getMyInitial}}</strong></span>
            </template>

            <AlertMessage :alerMessage="alerMessage"></AlertMessage>

            <v-row align="center">
              <v-col class="text-left" cols="12" md="6">
                <v-text-field
                  v-model="history.title"
                  label="Title"
                  hide-details
                  outlined
                  :disabled="loading"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="text-right"  cols="12" md="6">
                <v-textarea
                  v-model="history.description"
                  clearable
                  label="Description"
                  outlined
                  rows="1"
                  maxlength="255"
                  :disabled="loading"
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>

            <div class="my-6">
              <v-btn
                color="primary mr-4"
                depressed
                :disabled="loading"
                @click="submitHistory()">
                <span class="mx-4">Submit</span>
              </v-btn>
            </div>




            </v-timeline-item>
          </v-timeline>
          <v-timeline
            dense
            align-top
            v-for="(timeline, index) in histories"
            :key="index"
          >
            <v-timeline-item
              :color="statusColor(timeline.status)"
              small
              dense
              class="mt-n6"
            >
            <strong>{{ timeline.title }}</strong>
            <div class="text-caption">
              <span v-if="timeline.description">{{ timeline.description }}<br></span>
              {{ timeline.created_at | moment("MMM D, YYYY h:mm A") }}
            </div>

            </v-timeline-item>


          </v-timeline>

        </v-card-text>


      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import Loader from '@/components/Loader.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import BookingStatusSelect from '@/components/BookingStatusSelect.vue'
  import ActionButtons from '@/components/ActionButtons.vue'

  export default {
    name: 'AdminBookingView',
    data: () => ({
      adminNamespace: 'admin',
      isEditShippingMark: false,
      savingShippingMark: false,
      mnus: [],
      mnusItem: [],
      id: null,
      loading: false,
      loadingHistory: false,
      menuEstDeliveryDate: false,
      histories: [],
      history: {
        title: '',
        description: ''
      },
      actionBtnSettings: {
        edit: 0,
        save: 0,
        refresh: 0,
        close: 1,
        print: 0,
        send: 0,
        save_and_print: 0,
        save_disabled: false,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: false
      },
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      alerMessageUpdate:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      subNavs: [
        {
          text: 'Bookings',
          disabled: false,
          exact: true,
          to: {
            name: 'bookings'
          },
        },
        {
          text: 'View Booking',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      error:{
        show: false,
        status: '',
        error: '',
        messages: {}
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      booking: {
        id: '',
        client: '',
        sales_agent: '',
        container: '',
        created_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        target_delivery_date: '',
        items: []
      },
      items: [],
      containers: [],
      statuses: [],
      headers: [],
      saveChangesEnable: false
    }),
    watch: {
      booking: {
        handler () {
          this.saveChangesEnable = true
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters(['formatNumber', 'formatNumberAmount', 'formatNumberAmountNoComma', 'getStatusColor', 'getMyInitial', 'forSea']),
      forUpdate: function(){
        if(this.booking.status != this.$getConstBookingStatus('BOOKING_STATUS_CANCELLED')){
          return true
        }
        return false
      },
      canCancel: function(){
        if (parseInt(this.booking.status) < parseInt(this.$getConstBookingStatus('BOOKING_STATUS_ONGOING'))) {
          return true
        }
        return false
      },
      totalQty: function(){
        let qty = 0

        this.booking.items.forEach(obj => {
          qty = qty + Number(this.formatNumberAmountNoComma(this.$numeral, obj.qty))
        })
        return qty
      },
      totalCbm: function(){
        let cbm = 0
        this.booking.items.forEach(obj => {
          cbm = cbm + Number(this.formatNumberAmountNoComma(this.$numeral, obj.cbm))
        })
        return cbm
      },
      totalKg: function(){
        let kg = 0
        this.booking.items.forEach(obj => {
          kg = kg + Number(this.formatNumberAmountNoComma(this.$numeral, obj.kg))
        })
        return kg
      },
      totalLength: function(){
        let item_length = 0
        this.booking.items.forEach(obj => {
          item_length = item_length + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_length))
        })
        return item_length
      },
      totalWidth: function(){
        let item_width = 0
        this.booking.items.forEach(obj => {
          item_width = item_width + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_width))
        })
        return item_width
      },
      totalHeight: function(){
        let item_height = 0
        this.booking.items.forEach(obj => {
          item_height = item_height + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_height))
        })
        return item_height
      }
    },
    methods: {
      canDelete (item){
        if (parseInt(item.status) <= parseInt(this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED'))) {
          return true
        }
        return false
      },
      deleteItem (item) {
        this.booking.items.splice(this.booking.items.indexOf(item), 1)
      },
      addMoreItems(){
        this.booking.items.push(
          { id: 0 , description: '', qty: '', cbm: '', kg: '', item_length: '', item_width: '', item_height: '', status: this.booking.status }
        )
      },
      cancelUpdateShippingMark () {
        this.isEditShippingMark = false
        this.getBooking()
      },
      updateShippingMark () {
        let self = this
        this.savingShippingMark = true
        let data = { shipping_mark: this.booking.shipping_mark }
        this.$http.secured.post(this.adminNamespace+'/bookings/change-shipping-mark/'+this.id, data)
          .then(response => {
            this.isEditShippingMark = false
            this.showMessage("Shipping mark has been successfully changed", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.shipping_mark, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            self.$refs.shippingMark.focus()
          })
          .then(function () {
            self.savingShippingMark = false
          })
      },
      editShippingMark () {
        this.isEditShippingMark = true
        this.$refs.shippingMark.focus()
      },
      scrollToElement (element, body) {
        this.$scrollTo(
          element,
          500,
          {
            container: body,
            easing: 'ease-in',
            lazy: false,
            offset: -100,
            force: true,
            cancelable: true,
            onStart: function(element) {
              // scrolling started
            },
            onDone: function(element) {
              // scrolling is done
            },
            onCancel: function() {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
        )
      },
      confirmDelete (item) {
        this.dialog = {
          show: true,
          title: 'Delete Item',
          body: 'Are you sure you want to delete item '+item.description+'?',
          type: 'delete-item',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      readyForPickup (item) {
        this.dialog = {
          show: true,
          title: 'Arrived in Warehouse',
          body: 'Are you sure item '+item.description+' is arrived in warehouse?',
          type: 'ready-for-pickup',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      cancelBooking () {
        this.dialog = {
          show: true,
          title: 'Cancel Booking',
          body: 'Are you sure you want to cancel this booking?',
          type: 'cancel-booking',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doCancelBooking () {
        let self = this

        this.$http.secured.post(this.adminNamespace + '/bookings/cancel/'+this.booking.id, {})
          .then(response => {
            this.getBooking()
            this.showMessage("Booking has been successfully cancelled", 'success')
            this.getBookingHistory()
          })
          .catch(error => {
            if (error.response.data.error) {
              this.showMessage(error.response.data.messages.error, 'error')
            }else{
              this.showMessage(error.response.status + " - Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      doConfirm () {
        this.dialog.show = false

        if(this.dialog.type == 'ready-for-pickup'){
          this.doReadyForPickup()
        } else if(this.dialog.type == 'update-item-status'){
          this.doStatusChange()
        } else if(this.dialog.type == 'close'){
          this.$router.push({ name: 'bookings' })
        } else if(this.dialog.type == 'delete-item'){
          this.doDeleteBookingItem()
        } else if(this.dialog.type == 'cancel-booking'){
          this.doCancelBooking()
        }
      },
      doReadyForPickup () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/booking-items/ready-for-pickup/'+this.dialog.item.id)
          .then(response => {
            this.getBooking()
            this.showMessage(this.dialog.item.description + " has been successfully updated", 'success')
            this.getBookingHistory()
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            // self.loading = false
          })
      },
      doDeleteBookingItem () {
        this.loading = true
        let self = this
        this.$http.secured.delete(this.adminNamespace+'/booking-items/'+ this.dialog.item.id)
          .then(response => {
            this.getBooking()
            this.showMessage(this.dialog.item.description + " has been successfully deleted", 'success')
            this.getBookingHistory()
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            // self.loading = false
          })
      },
      doCancel () {
        this.dialog.show = false
      },
      isReadyForPickup (item){
        if(!item.ready_for_pickup_date &&
          parseInt(item.status) != parseInt(this.$getConstBookingStatus('BOOKING_STATUS_CANCELLED')) &&
          parseInt(item.status) >= parseInt(this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED'))){
          return true
        }
      },
      computeCBM (item){
        let totalCBM = (Number(this.formatNumberAmountNoComma(this.$numeral, item.item_length)) *
          Number(this.formatNumberAmountNoComma(this.$numeral, item.item_width)) *
          Number(this.formatNumberAmountNoComma(this.$numeral, item.item_height))) / 1000000

        return Number(this.formatNumberAmountNoComma(this.$numeral, item.qty)) * totalCBM
      },
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      checkShipmentType (){
        if(this.isShipmentForSea(this.booking.shipment_type)){
          this.headers = [
            {
              text: 'Container',
              align: 'start',
              value: 'container_id',
              sortable: false,
              width: 180
            },
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 90
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 90
            },
            {
              text: 'Length',
              align: 'center',
              value: 'item_length',
              sortable: false,
              width: 90
            },
            {
              text: 'Width',
              align: 'center',
              value: 'item_width',
              sortable: false,
              width: 90
            },
            {
              text: 'Height',
              align: 'center',
              value: 'item_height',
              sortable: false,
              width: 90
            },
            {
              text: 'CBM',
              align: 'center',
              value: 'cbm',
              sortable: false,
              width: 100
            },
            {
              text: 'Status',
              align: 'center',
              value: 'status',
              sortable: false,
              width: 100,
            },
            {
              text: '',
              align: 'right',
              value: 'action',
              sortable: false,
              width: 70,
            },
          ]
        }else{
          this.headers = [
            {
              text: 'Container',
              align: 'start',
              value: 'container_id',
              sortable: false,
              width: 210
            },
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 120
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 120
            },
            {
              text: 'Status',
              align: 'center',
              value: 'status',
              sortable: false,
              width: 120,
            },
            {
              text: '',
              align: 'right',
              value: 'action',
              sortable: false,
              width: 70,
            },
          ]
        }
      },
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      statusColor (statusId){
        return this.getStatusColor(statusId, this)
      },
      forEdit(item){
        if(item.status == this.$getConstBookingStatus('BOOKING_STATUS_PENDING') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_INVOICE_CREATED') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_INVOICE_SENT') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_FOR_DELIVERY') ||
          item.status == this.$getConstBookingStatus('BOOKING_STATUS_ONGOING')){
          return true
        }
        return false
      },
      getMnu(){
        if(this.booking.status == this.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED')){
          this.mnus = [this.$getConstBookingStatus('BOOKING_STATUS_ONGOING')];
        }else if(this.booking.status == this.$getConstBookingStatus('BOOKING_STATUS_ONGOING')){
          this.mnusItem = [this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED')];
        }


        // this.allowedStatusBookingItems = [
        //   this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED'),
        //   this.booking.status
        // ]
      },
      statusChange (item) {
        this.dialog = {
          show: true,
          title: 'Confirm Change Status',
          body: 'Are you sure you want to update item status?',
          type: 'update-item-status',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doStatusChange () {
        let url = '';
        let self = this

        if(this.dialog.item.bookingType == 'main'){
          this.booking.status = this.dialog.item.status

          this.booking.items.forEach(obj => {
            obj.status = this.dialog.item.status
          })
          url = '/bookings/update-status/'+this.dialog.item.id
        }else{
          url = '/booking-items/update-status/'+this.dialog.item.id

          this.booking.items.forEach(obj => {
            if(this.dialog.item.id == obj.id){
              obj.status = this.dialog.item.status
            }
          })
        }

        let status = { status: this.dialog.item.status }

        this.$http.secured.post(this.adminNamespace + url, status)
          .then(response => {
            self.saveChangesEnable = false
            this.getMnu()
            this.getBookingHistory()
            this.showMessage(this.booking.shipping_mark + " has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response.data.error) {
              this.error.messages = error.response.data.error
              this.error.show = true
            }else{
              this.error.messages = [error.response.data]
              this.error.show = true
              this.showMessage(error.response.status + " - Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      doClose (){
        this.dialog = {
          show: true,
          title: 'Close Booking',
          body: 'Are you sure you want to close this booking?',
          type: 'close',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      gotoBookings () {
        this.$router.push({ name: 'bookings' })
      },
      getBooking () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/bookings/'+this.id)
          .then(response => {
            this.booking = response.data
            this.containers = this.booking.containers
            this.containers.unshift({ id: '', name: 'No Container' })
            this.getMnu()
            this.checkShipmentType()

            setTimeout(function(){
              self.saveChangesEnable = false
              self.getBookingHistory()
            }, 100);

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      getBookingHistory () {
        this.loadingHistory = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/booking-history/'+this.id)
          .then(response => {
            this.histories = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loadingHistory = false
          })
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?booking_statuses=true')
          .then(response => {
            this.statuses = response.data.booking_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      submitHistory (){
        let self = this
        this.loading = true
        this.alerMessage.show = false
        this.history['booking_id'] = this.id
        this.$http.secured.post(this.adminNamespace+'/booking-history', this.history)
          .then(response => {
            this.clear()
            this.getBookingHistory()
            this.showMessage("Booking history has been successfully created", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      update () {
        let self = this
        this.alerMessageUpdate.show = false
        this.$http.secured.put(this.adminNamespace+'/bookings/'+this.id, this.booking)
          .then(response => {
            this.getBooking()
            this.showMessage("Booking "+this.booking.shipping_mark +" has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessageUpdate.messages = error.response.data.messages
              this.alerMessageUpdate.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            this.scrollToElement('body', 'body')
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clear () {
        Object.keys(this.history).forEach(key => {
          this.history[key] = ''
        })
      },
    },
    mounted() {
      this.id = this.$route.params.id
      this.getBooking()
      this.getDefaultData()
    },
    components: {
      BookingStatusSelect,
      AlertMessage,
      SnackBar,
      Loader,
      ActionButtons,
      ConfirmationDialog
    }
  }
</script>
